import React from "react";
import "../../zisComponents/grid/Grid.scss";
import "./Faktury.scss";
import { GridDetailRow } from "@progress/kendo-react-grid";

export default function Detail() {
  return class extends GridDetailRow {
    render() {
      const { dataItem } = this.props;
      const { FaktObsahy } = dataItem;

      return (
        <>
          {FaktObsahy.length !== 0 && (
            <>
              <div className="row m-0">
                <div className="col-2 p-0 gridDetailCol centerFaktDetail">
                  <p>
                    <strong>Názov položky</strong>
                  </p>
                </div>
                <div className="col-2 p-0 gridDetailCol centerFaktDetail">
                  <strong>Množstvo</strong>
                </div>
                <div className="col-2 p-0 gridDetailCol centerFaktDetail">
                  <strong>Merná jednotka</strong>
                </div>
                <div className="col-2 p-0 gridDetailCol centerFaktDetail">
                  <strong>Jednotková cena</strong>
                </div>
                <div className="col-2 p-0 gridDetailCol centerFaktDetail">
                  <strong>Cena faktúry bez DPH</strong>
                </div>
                <div className="col-2 p-0 gridDetailCol centerFaktDetail">
                  <strong>Cena faktúry s DPH</strong>
                </div>
              </div>

              <div className="row m-0">
                {FaktObsahy.map((d, key) => {
                  return (
                    <React.Fragment key={key}>
                      <div className="col-2 p-0 gridDetailCol centerFaktDetail">
                        <p>{d.UCT_POLOZKA_NAZOV}</p>
                      </div>
                      <div className="col-2 p-0 gridDetailCol centerFaktDetail">
                        {d.MNOZSTVO}
                      </div>
                      <div className="col-2 p-0 gridDetailCol centerFaktDetail">
                        {d.MJ}
                      </div>
                      <div className="col-2 p-0 gridDetailCol centerFaktDetail">
                        {d.JEDNCENA_F}
                      </div>
                      <div className="col-2 p-0 gridDetailCol centerFaktDetail">
                        {d.CENABEZDPH_F}
                      </div>
                      <div className="col-2 p-0 gridDetailCol centerFaktDetail">
                        {d.CENASDPH_F}
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>
            </>
          )}
        </>
      );
    }
  };
}
